import Dialog from '../../../components/Dialog';
import { REC_CODES } from '../../../lib/recommendations';
import SchemaFix from './fixes/SchemaFix';
import FaqFix from './fixes/FaqFix';
import CapsulesFix from './fixes/CapsulesFix';
import HeadingsFix from './fixes/HeadingsFix';
import BotAccessFix from './fixes/BotAccessFix';
import LlmsTxtFix from './fixes/LlmsTxtFix';
import ContentQualityFix from './fixes/ContentQualityFix';
import {
  FileCode,
  HelpCircle,
  MessageSquareQuote,
  Heading1,
  Bot,
  FileText,
  Newspaper,
} from 'lucide-react';

const FIX_META = {
  [REC_CODES.SCHEMA]: {
    title: 'Add JSON-LD schema',
    description: 'Copy structured-data scripts into your page <head>.',
    icon: FileCode,
    Component: SchemaFix,
    size: 'lg',
  },
  [REC_CODES.FAQ]: {
    title: 'Add an FAQ section',
    description: 'Paste a ready-made FAQ section into your page body.',
    icon: HelpCircle,
    Component: FaqFix,
    size: 'lg',
  },
  [REC_CODES.CAPSULES]: {
    title: 'Surface Answer Capsules',
    description: 'Paste short standalone fact blockquotes AI can quote verbatim.',
    icon: MessageSquareQuote,
    Component: CapsulesFix,
    size: 'lg',
  },
  [REC_CODES.HEADINGS]: {
    title: 'Fix heading hierarchy',
    description: 'Review and correct your <h1>/<h2>/<h3> structure.',
    icon: Heading1,
    Component: HeadingsFix,
    size: 'lg',
  },
  [REC_CODES.BOT_ACCESS]: {
    title: 'Allow AI crawlers',
    description: 'Toggle which AI bots can crawl your domain.',
    icon: Bot,
    Component: BotAccessFix,
    size: 'md',
  },
  [REC_CODES.LLMS_TXT]: {
    title: 'Publish llms.txt',
    description: 'Configure and download your domain’s llms.txt file.',
    icon: FileText,
    Component: LlmsTxtFix,
    size: 'xl',
  },
  [REC_CODES.CONTENT_QUALITY]: {
    title: 'Improve content quality',
    description: 'Add author byline, publish date, and depth to thin pages.',
    icon: Newspaper,
    Component: ContentQualityFix,
    size: 'lg',
  },
};

export default function FixModal({ code, domain, audit, onClose, onFixApplied }) {
  const meta = code ? FIX_META[code] : null;
  if (!meta) return null;
  const { Component } = meta;
  return (
    <Dialog
      open={Boolean(code)}
      onClose={onClose}
      title={meta.title}
      description={meta.description}
      icon={meta.icon}
      size={meta.size}
    >
      <Component domain={domain} audit={audit} onFixApplied={onFixApplied} />
    </Dialog>
  );
}
